export var WarningTypes;
(function (WarningTypes) {
    WarningTypes["AFTER_CUTOFF"] = "AFTER_CUTOFF";
    WarningTypes["RTP_ELIGIBILITY"] = "RTP_ELIGIBILITY";
    WarningTypes["BALANCE_TOO_LOW"] = "BALANCE_TOO_LOW";
    WarningTypes["AMOUNT_ABOVE_LIMIT"] = "AMOUNT_ABOVE_LIMIT";
    WarningTypes["MAX_FEE"] = "MAX_FEE";
})(WarningTypes || (WarningTypes = {}));
